var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" },
            React.createElement("path", { d: "M20.772 32.38l-.98-.979-6.526 6.527c-.666.666-1.994.417-2.617-.206s-.877-1.957-.21-2.622l6.526-6.527-.975-.974c-.89-.89-1.677-1.47-1.41-2.156.297-.773.944-.639 2.673-.7l4.948-.168a1.523 1.523 0 011.595 1.595l-.168 4.949c-.062 1.739.043 2.401-.707 2.677-.668.246-1.266-.532-2.149-1.416zM27.228 15.972l.98.98 6.526-6.527c.666-.666 1.994-.417 2.617.205.623.623.877 1.957.21 2.623l-6.526 6.526.975.975c.89.89 1.677 1.469 1.41 2.155-.297.774-.944.64-2.673.7l-4.948.168a1.523 1.523 0 01-1.595-1.595l.168-4.948c.062-1.74-.043-2.402.707-2.678.668-.246 1.266.533 2.149 1.416z" }))));
});
